// extracted by mini-css-extract-plugin
module.exports = {"externalHeader":"XDWYazn0S58Nms-ULc95I","dialog":"wzuGgIQqEMj1cklp6iTJM"};